/**
 * Rutas de la aplicacion.
 *
 * Las URL publicas son legibles a proposito —`/producto/broca-punta-centradora`
 * y no `/p/5896`— porque es parte de lo comprometido para SEO (`SEO-01`): el
 * resultado de Google tiene que inspirar confianza antes de que alguien haga
 * clic. Los patrones viven en `utilidades/rutas.ts`, no escritos a mano aca.
 *
 * Hay tres armazones, no dos: la tienda lleva cabecera y pie; el backoffice,
 * barra lateral; y el acceso —entrar y elegir clave— no lleva ninguno de los
 * dos, porque quien esta ahi todavia no tiene panel que enmarcar.
 */
import { Route, Routes } from 'react-router-dom';

import { DisenoAdmin } from './componentes/administracion/DisenoAdmin';
import { DisenoTienda } from './componentes/diseno/DisenoTienda';
import { Busqueda } from './paginas/Busqueda';
import { Carro } from './paginas/Carro';
import { Categoria } from './paginas/Categoria';
import { Checkout } from './paginas/Checkout';
import { ConfirmacionPedido } from './paginas/ConfirmacionPedido';
import { FichaProducto } from './paginas/FichaProducto';
import { Inicio } from './paginas/Inicio';
import { Linea } from './paginas/Linea';
import { NoEncontrado } from './paginas/NoEncontrado';
import { Acceso } from './paginas/administracion/Acceso';
import { Administradores } from './paginas/administracion/Administradores';
import { Busquedas } from './paginas/administracion/Busquedas';
import { CambiarClave } from './paginas/administracion/CambiarClave';
import { CotizacionNueva } from './paginas/administracion/CotizacionNueva';
import { Cotizaciones } from './paginas/administracion/Cotizaciones';
import { Despacho } from './paginas/administracion/Despacho';
import { Inventario } from './paginas/administracion/Inventario';
import { Panel } from './paginas/administracion/Panel';
import { Pedidos } from './paginas/administracion/Pedidos';
import { Portada } from './paginas/administracion/Portada';
import { ProductoDetalle } from './paginas/administracion/ProductoDetalle';
import { ProductoNuevo } from './paginas/administracion/ProductoNuevo';
import { Productos } from './paginas/administracion/Productos';

export function Enrutador() {
  return (
    <Routes>
      <Route element={<DisenoTienda />}>
        <Route path="/" element={<Inicio />} />
        <Route path="/linea/:slug" element={<Linea />} />
        <Route path="/categoria/:slug" element={<Categoria />} />
        <Route path="/producto/:slug" element={<FichaProducto />} />
        <Route path="/buscar" element={<Busqueda />} />
        <Route path="/carro" element={<Carro />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout/confirmacion" element={<ConfirmacionPedido />} />
        <Route path="*" element={<NoEncontrado />} />
      </Route>

      {/* Fuera del armazon del panel: se ven sin sesion, o con la clave temporal. */}
      <Route path="/admin/acceso" element={<Acceso />} />
      <Route path="/admin/clave" element={<CambiarClave />} />

      <Route path="/admin" element={<DisenoAdmin />}>
        <Route index element={<Panel />} />
        <Route path="portada" element={<Portada />} />
        <Route path="productos" element={<Productos />} />
        {/* Antes que `:id`: si no, "nuevo" se leeria como el id de un producto. */}
        <Route path="productos/nuevo" element={<ProductoNuevo />} />
        <Route path="productos/:id" element={<ProductoDetalle />} />
        <Route path="pedidos" element={<Pedidos />} />
        <Route path="cotizaciones" element={<Cotizaciones />} />
        <Route path="cotizaciones/nueva" element={<CotizacionNueva />} />
        <Route path="despacho" element={<Despacho />} />
        <Route path="busquedas" element={<Busquedas />} />
        <Route path="inventario" element={<Inventario />} />
        <Route path="administradores" element={<Administradores />} />
      </Route>
    </Routes>
  );
}
